import {API} from 'aws-amplify';
import axios from 'axios';
import querystring from 'querystring';

// @ts-ignore
export const create = (one) => API.put('ihrespezialistenBackend', '/campaignArticles', {body: one});

// @ts-ignore
export const read = () => API.get('ihrespezialistenBackend', '/campaignArticles', {});

// @ts-ignore
export const readOne = (id) => API.get('ihrespezialistenBackend', `/campaignArticles/${id}`, {});

// @ts-ignore
export const readByCampaignId = (id) => API.get('ihrespezialistenBackend', `/campaignArticles/campaign/${id}`, {});

// @ts-ignore
export const update = (one) => API.post('ihrespezialistenBackend', `/campaignArticles/${one.id}`, {body: one});

// @ts-ignore
export const remove = (id) => API.del('ihrespezialistenBackend', `/campaignArticles/${id}`, {});
